<template>
  <div class="rankLine">
    <div v-for="(item, i) in props.list" :key="i" class="rank">
      <div class="line">
        <div class="icon">
          <img v-if="i === 0" src="@/assets/images/award/golden.png" />
          <img v-if="i === 1" src="@/assets/images/award/silver.png" />
          <img v-if="i === 2" src="@/assets/images/award/bronze.png" />
          <p v-if="i > 2">{{ item.value }}</p>
        </div>
        <p class="name">{{ item?.name || '-' }}</p>
      </div>
      <Separate
        v-if="i + 1 !== props.list.length"
        :style="{ height: '1px', background: 'rgba(220,222,225,0.51)' }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import Separate from '@core/components/separate.vue'
import { getInspireResp } from '@/model/award/award'
const props = defineProps<{ list: getInspireResp }>()
</script>

<style scoped lang="less">
.rankLine {
  .rank {
    .line {
      height: 54px;
      display: flex;
      flex-direction: row;
      //padding: 8px;
      align-items: center;
      .icon {
        width: 50px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        > img {
          width: 32px;
          height: 32px;
        }
        > p {
          text-align: center;
        }
      }
      .name {
        flex: 1;
        text-align: center;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1; /* 限制显示 2 行 */
        overflow: hidden;
      }
    }
  }
}
</style>
